import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box } from '@chakra-ui/react'
import useStore from '../../../store'
import { Widget, WidgetHeader, WidgetBody } from '../../ui/Widget'
import Spinner from '../../common/Spinner'
import OrderResult from './OrderResult'
import useCarpoolOrdersSubscription from '../../../hooks/useCarpoolOrdersSubscription'
import BackButton from '../../common/BackButton'
import useTransportationBasePath from '../../../hooks/useTransportationBasePath'
import CarpoolSupportButton from '../CarpoolSupportButton'

export default function CarpoolOrderPage({ orderId: orderIdProp, onBack }) {
  useCarpoolOrdersSubscription()
  const params = useParams()
  const orderId = orderIdProp ?? params.orderId
  const { t } = useTranslation()
  const navigate = useNavigate()
  const basePath = useTransportationBasePath()
  const { carpoolOrder, getCarpoolOrder } = useStore()
  const [loading, setLoading] = useState(!carpoolOrder || String(carpoolOrder.id) !== orderId)

  useEffect(() => {
    setLoading(true)
    getCarpoolOrder(orderId).finally(() => setLoading(false))
  }, [orderId])

  const isReady = carpoolOrder && String(carpoolOrder.id) === orderId

  const handleBack = onBack ? onBack : () => navigate(`${basePath}/orders`)

  return (
    <Widget>
      <WidgetHeader
        title={t('Transport Order')}
        showSpinner={loading}
        actionIcon={<CarpoolSupportButton />}
        overrideHeaderStyle={true}
      >
        <BackButton
          styles="w-fit text-grey-300 hover:text-grey-100"
          label={t('All Orders')}
          onClick={handleBack}
        />
      </WidgetHeader>
      <WidgetBody isVisible={isReady}>
        {isReady && <OrderResult order={carpoolOrder} />}
      </WidgetBody>
    </Widget>
  )
}
